module.exports = __webpack_public_path__ + "static/img/beijing2.198dc8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/beijing2.jpg
// module id = gnyt
// module chunks = 1